import { useMutation, useQueryClient } from "@tanstack/react-query";

import { Notification } from "@/Components";
import { NEST_BACKEND_URL } from "@/lib/axios";
import { axiosApi } from "@/Utils";

export const deleteUser = async (cmsUserId: string): Promise<void> => {
  await axiosApi.delete(`/api/team/users/${cmsUserId}`, {
    cache: false,
    baseURL: NEST_BACKEND_URL,
  });
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: () => {
      Notification("success", "Delete user successful.");
      console.log("Delete user success - removing and refetching queries");
      // Remove the query completely and refetch
      queryClient.removeQueries({ queryKey: ["team-users"] });
      // Add a small delay to allow backend to process the deletion
      queryClient.refetchQueries({ queryKey: ["team-users"] });
    },
    onError: (error) => {
      Notification("error", "Delete user fail.");
      console.error("Delete user error:", error);
    },
  });
};

export const deleteUserInvitation = async ({
  cmsUserId,
  invitationId,
}: {
  cmsUserId: string;
  invitationId: string;
}): Promise<void> => {
  await axiosApi.delete(`/api/team/users/${cmsUserId}/invitation/${invitationId}`, {
    cache: false,
    baseURL: NEST_BACKEND_URL,
  });
};

export const useDeleteUserInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUserInvitation,
    onSuccess: () => {
      Notification("success", "Delete user invitation successful.");
      console.log("Delete user success - removing and refetching queries");
      // Remove the query completely and refetch
      queryClient.removeQueries({ queryKey: ["team-users"] });
      // Add a small delay to allow backend to process the deletion
      queryClient.refetchQueries({ queryKey: ["team-users"] });
    },
    onError: (error) => {
      Notification("error", "Delete user invitation fail.");
      console.error("Delete user invitation error:", error);
    },
  });
};
